import gql from "graphql-tag"

export default gql`
  fragment showFragment on Show {
    id
    name
    additionDate
    tmdbOptions
    status
    Season {
      id
      number
    }
  }
`
